var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlainFilesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7794_57115)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#E2E6F5"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7794_57115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3565 9.93884H12.9462L10.5623 12.0079V23.3989H20.3565V9.93884Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3565 23.9611H10.5622L10 23.3989V12.0079L10.1912 11.5806L12.5751 9.51152L12.9461 9.37659H20.3565L20.9187 9.93883V23.3989L20.3565 23.9611ZM11.1245 22.8366H19.7942V10.5011H13.1598L11.1245 12.2553V22.8366Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6842 17.4392H21.5597V8.72446H14.1719V7.59998H22.122L22.6842 8.16222V17.4392Z",
    fill: "#4611A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5348 13.0311H12.3839V13.8745H18.5348V13.0311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5348 14.6393H12.3839V15.4826H18.5348V14.6393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5348 16.2473H12.3839V17.0907H18.5348V16.2473Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9268 17.8553H12.3839V18.6987H16.9268V17.8553Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.791 19.4744H12.3839V20.3177H15.791V19.4744Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7794_57115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7794_57115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.619,
    height: 19.1836,
    fill: "white",
    transform: "translate(10 7.59998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlainFilesIcon);
export default __webpack_public_path__ + "static/media/plain-files-icon.f1c5e57e51754c91c7759656f48efc21.svg";
export { ForwardRef as ReactComponent };